const {
  langContentEN,
  langContentES,
  langContentPtBR,
} = require('../config/language-imports')

const supportLanguages = ['pt-BR', 'en', 'es']
const fallbackLng = 'en'

function getContentByLanguage(lang) {
  const langKey = typeof lang === 'string' ? lang.toLowerCase() : ''

  return (
    {
      en: langContentEN,
      es: langContentES,
      'pt-br': langContentPtBR,
    }[langKey] || {}
  )
}

function detectBrowserLanguage() {
  return (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLang
  )
}

function getLanguageDetected() {
  const detectLng = typeof window !== 'undefined' ? detectBrowserLanguage() : ''

  const options = (detectedLng, lng) => {
    return { browser: detectedLng, language: lng }
  }
  const curryLanguage = detectedLng => lng => options(detectedLng, lng)

  const getCountry = curryLanguage(detectLng)
  const getLanguage = getCountry(detectLng.substr(0, 2))

  return (
    supportLanguages.find(
      el => el === getLanguage.browser || el === getLanguage.language
    ) || fallbackLng
  )
}

module.exports = {
  getContentByLanguage,
  getLanguageDetected,
}
